/*
 * Whether this account is a dedicated test account exempt from MFA (CLUB-950) — automation
 * and app-store review logins. Member Hub returns it as a root-level `bypass_MFA` boolean on
 * /profile, from its own users.mfa_bypass column, which only its `users:mfa-bypass` command
 * can set. The browser never decides this itself.
 *
 * Only an explicit true counts. A missing field (an older backend), a missing profile or any
 * other value is false, so nothing short of Member Hub saying so can switch MFA off.
 */
export default function useMfaBypassFlag () {
  const userStore = useUserStore()
  return computed(() => userStore.getUserProfile?.bypass_MFA === true)
}
